// src/components/home/HomeFaq.js
// Visible FAQ section. The homepage FAQPage JSON-LD (SEO/StructuredData.js) is
// built from the same `home_faq` locale keys, so the markup always matches what
// the visitor can actually read - a requirement for FAQ structured data.
import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../SectionTitle';

const HomeFaq = () => {
    const { t } = useTranslation();
    const items = t('home_faq.items', { returnObjects: true });
    if (!Array.isArray(items) || !items.length) return null;

    return (
        <section className="bg-gray-50 py-12" id="faq">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionTitle title={t('home_faq.title')} subtitle={t('home_faq.subtitle')} />
                <div className="mt-6 space-y-4">
                    {items.map((item) => (
                        <div key={item.q} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                            <h3 className="font-bold text-gray-900 text-lg mb-2">{item.q}</h3>
                            <p className="text-gray-600 leading-relaxed">{item.a}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeFaq;
